module.exports = __webpack_public_path__ + "static/media/saas4.f604a9b2.png";